export default __webpack_public_path__ + "static/media/vector-deposit-button.2d931bf8.svg";